<template>
  <bean-source-page
    :type="type"
    :columns="columns"
    :form-columns="formColumns"
    :filter-columns="filterColumns"
    :onFetchData="onFetchData"
    :actions="actions"
    :onFormSubmit="handleSubmit"
    :form="form"
    title="站点设置"
    resource="settings"
  />
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component
export default class Setting extends Vue {
  @Prop(String) type;

  // form 新建表单初始化数据（default数据）
  form = {}

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  filterColumns() {
    return [];
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   */
  columns() {
    return [
      {
        prop: 'customer_service_phone',
        label: '客服电话'
      },
      {
        prop: 'customer_service_email',
        label: '客服邮箱'
      },
      {
        prop: 'customer_service_wechat',
        label: '客服微信'
      }
    ];
  }

  async onFetchData() {
    if (this.type === 'edit' || this.type === 'show') {
      const data = await this.$request.get('/settings');
      return {  data }
    }
  }

  async handleSubmit({ data }) {
    try {
      this.formLoading = true;
      let body = data;
      await this.$request.put('/settings', body);
      this.$message.success('更新成功');
      this.$router.push({ name: 'settings.show' });
    } finally {
      this.formLoading = false;
    }
  }

  /**
   * @param {Function} h - createElement
   * @param {Object} params
   * @param {String} params.type - 页面类型 enum: ['index', 'show', 'edit', 'new']
   * @param {String} params.resource -页面RESTful api资源名
   * @param {Object} params.data - 当前表单数据
   * @param {Function} params.change - 调用此方法同步表单数据 change({ field: 'new value' })
   */
  formColumns() {
    return [
      {
        prop: 'customer_service_phone',
        label: '客服电话',
        renderCell: {
          component: 'input',
        }
      },
      {
        prop: 'customer_service_email',
        label: '客服邮箱',
        renderCell: {
          component: 'input',
        }
      },
      {
        prop: 'customer_service_wechat',
        label: '客服微信',
        renderCell: {
          component: 'input',
        }
      },
    ];
  }

   /**
   * @param {Object} scope -页面/表格 scope 数据
   * @param {Object} scope.row - 详情页/表格行 数据
   * @param {Object} sourcePageScope
   * @param {Function} sourcePageScope.remove - sourcePage删除方法
   * @param {Function} sourcePageScope.reload - sourcePage重新请求页面数据
   */
  actions() {
    return [
      {
        component: 'routeButton',
        props: {
          label: '编辑',
          to: { name: 'settings.edit' }
        }
      }
    ].filter(Boolean);
  }
}


export const route = [
  {
    path: '/settings',
    name: 'settings.show',
    component: Setting,
    props: {
      type: 'show'
    },
    meta: {
      backBtn: false
    }
  },
  {
    path: '/settings/edit',
    name: 'settings.edit',
    component: Setting,
    props: {
      type: 'edit',
    }
  },
]
</script>
